<template>
<div :style="{height: editorHeight + 'px'}" ref="cmContainer"></div>
</template>

<script>

import {EditorState, EditorView, basicSetup} from "@codemirror/basic-setup";
import {
  oneDarkTheme,
  oneDarkHighlightStyle
} from '@codemirror/theme-one-dark';

import matchBrackets from '@codemirror/matchbrackets';
import {defaultTabBinding} from '@codemirror/commands';
import {keymap, inputHandler} from '@codemirror/view';
import {history, historyKeymap} from "@codemirror/history";
import { defaultHighlightStyle } from '@codemirror/highlight';

import {amazingLanguage} from '../api/amazingLanguage.js';

const extensionsConfig = [
  basicSetup,
  oneDarkTheme,
  oneDarkHighlightStyle,
  EditorState.tabSize.of(2),
  keymap.of([defaultTabBinding]),
  amazingLanguage
]

export default {
  props : {
    initialCode: {
      type: String,
      default: ""
    },
    task: {
      type: String
    },
    editorHeight: {
      type: Number
    }
  },
  data(){
    return {
      editor: null,
      listener: EditorView.updateListener.of(editorUpdate => {
        if(!editorUpdate.docChanged)return;
        this.$emit("input", editorUpdate.state.doc.toString());
      }),
    }
  },
  methods: {
    async destroy() {
      if(this.editor)
        this.editor.destroy();
    }
  },
  beforeDestroy() {
    this.destroy();
  },
  async mounted() {
    this.editor = new EditorView({
      state: EditorState.create({
        doc: this.initialCode,
        extensions: [
          ...extensionsConfig,
          this.listener
        ]
      }),
      parent: this.$refs.cmContainer
    });
  }
}
</script>
